import Vue from 'vue'

import hzlInput from './hzlInput.vue'
import hzlSelect from './hzlSelect.vue'
import hzlPage from './hzlPage.vue'
import hzlTable from './hzlTable.vue'
import hzlDialog from './hzlDialog.vue'

Vue.component('hzl-input',hzlInput);
Vue.component('hzl-select',hzlSelect);
Vue.component('hzl-page',hzlPage);
Vue.component('hzl-table',hzlTable);
Vue.component('hzl-dialog',hzlDialog);



// WEBPACK FOOTER //
// ./src/components/template/index.js